import { render, staticRenderFns } from "./members.vue?vue&type=template&id=50936bd3&"
import script from "./members.vue?vue&type=script&lang=ts&"
export * from "./members.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports